import { Spacing } from '@persona-id/design-tokens';
import { ArrowLeftIcon } from '@persona-id/design-tokens/icons';
import { castArray } from 'lodash/fp';
import { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import { paragraphMixins } from 'design-system/mixins/text';
import { intersperse } from 'lib/utils/array';

const Container = styled('div')`
  display: flex;
  align-items: center;
  margin-right: ${Spacing[2]};
`;

const NavBackLink = styled(Link)`
  height: 26px;
  padding: ${Spacing[1]};

  cursor: pointer;
  color: ${({ theme }) => theme.color.text.primary};

  display: flex;
  align-items: center;

  white-space: nowrap;
  margin-left: -${Spacing[2]};

  svg {
    transform: translateX(2px);
  }

  &:hover,
  &:focus {
    svg {
      transform: translateX(-2px);
    }
  }
`;

const StyledIconNavBack = styled(ArrowLeftIcon)`
  flex: none;
  transition: transform 0.2s;

  rect[stroke],
  path[stroke] {
    stroke: ${({ theme }) => theme.color.text.primary};
  }
`;

const Label = styled('span')`
  ${paragraphMixins.lgBold}
  margin-left: ${Spacing[3]};
  color: ${({ theme }) => theme.color.text.tertiary};

  /* Last two children (last element and leading divider) are black */
  > :nth-last-child(-n + 2) {
    color: ${({ theme }) => theme.color.text.primary};
  }
`;

interface NavBackProps extends LinkProps {
  children?: ReactNode | ReactNode[];
  dataTest?: string;
}

export default ({ className, dataTest, children, ...linkProps }: NavBackProps) => {
  const textNodes = castArray(children).map((child, idx) => (
    <span key={`child-${idx}`}>{child}</span>
  ));

  return (
    <Container className={className}>
      <NavBackLink data-test={dataTest} {...linkProps}>
        <StyledIconNavBack height={16} width={16} />
        {children != null && (
          <Label>
            {intersperse(textNodes, (i) => (
              <span key={`separator-${i}`}>{' / '}</span>
            ))}
          </Label>
        )}
      </NavBackLink>
    </Container>
  );
};
